module.exports = __webpack_public_path__ + "img/bubbl.us.png";